import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const fetchPermissions = () => {
  return API.get(`${getApiUrl()}/api/permissions/discover`);
};

export const permissionService = {
  fetchPermissions
}; 